import { render, staticRenderFns } from "./RuleConfig.vue?vue&type=template&id=30283d61&scoped=true&"
import script from "./RuleConfig.vue?vue&type=script&lang=js&"
export * from "./RuleConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30283d61",
  null
  
)

export default component.exports